import { createContext, use } from "react";

export const IpContext = createContext<string | null>(null);

export const useIp = () => use(IpContext);